import {
  CheckoutLeft,
  CheckoutRight,
  CheckoutWrapper,
  Imgage,
  Label,
  Name,
  NameQty,
  ProductImageWrapper,
  ProductInfo,
  ProductInfo1,
  ProductPrice,
  QtyNum,
  Quantity,
  SubSummaryWrapper,
  SubTax,
  SummaryWrapper,
  Title,
  Value,
  Value1,
  Wrapper,
} from "./CheckoutComponent.styled";
import { useNavigate, useSearchParams } from "react-router-dom";
import { productDetails, transformPrice } from "./data";
import { useStore } from "@nanostores/react";
import {
  checkoutProduct,
  selectedProduct,
  brandSettings,
  totalCheckoutAmount,
} from "../../store/nanostore";
import React from "react";
import { inputEventMock } from "../../utils/input";
import { safeJson } from "../../utils/safeJson";

const CheckoutPageComponent = ({ readOnly }: any) => {
  const navigate = useNavigate();
  const $checkoutProduct = useStore(checkoutProduct);
  const $selectedProduct = useStore(selectedProduct);
  const $brandSettings = useStore(brandSettings);
  const [params] = useSearchParams();
  const visaState = safeJson(params.get("state")) || {};

  const totalPrice = $selectedProduct?.reduce(
    (acc: any, cur: any) => acc + (cur?.price || 0) * (cur?.quantity || 1),
    0
  );

  const updateAdhocProductAmount = (event: any) => {
    event.preventDefault();
    const price = event.target.value || visaState?.productPrice;
    // this just for now. will need to compute tax and other payments
    totalCheckoutAmount.set(price);
    selectedProduct.set([{ price: price, totalPrice: price }]);
  };

  const handleProductUpdate = (
    index: number,
    event: any,
    ProductInstance: any
  ) => {
    const price = event.target.value || visaState?.productPrice;
    if (
      ProductInstance?.quantity < Number(price) ||
      ProductInstance?.quantity === 0
    ) {
      event.target.value = ProductInstance.quantity;
    }
    event.preventDefault();
    const quantity = Number(price) as number;
    const products: any = Array.from(
      $selectedProduct || $checkoutProduct?.products || []
    );
    if (!products?.length) return;
    const product: any = { ...products[index], quantity };
    products[index] = product;
    selectedProduct.set(products);
    totalCheckoutAmount.set(totalPrice);
  };

  React.useEffect(() => {
    ($checkoutProduct?.products || [])?.forEach(
      ({ ProductInstance }: any, index: number) => {
        handleProductUpdate(index, inputEventMock(1), ProductInstance);
      }
    );
    totalCheckoutAmount.set(totalPrice);
    if (!$checkoutProduct?.products?.length) {
      selectedProduct.set([{ price: 0 }]);
    }
  }, []);

  React.useEffect(() => {
    if (Object.keys(visaState)?.length > 0) {
      updateAdhocProductAmount(inputEventMock(visaState.productPrice));
    }
  }, []);

  return (
    <CheckoutWrapper>
      <Imgage>
        <img
          onClick={() => navigate("/")}
          src={$brandSettings?.primaryLogo || "/assets/icons/fipay.svg"}
          alt="fipay"
          className="fipay_img"
        />
      </Imgage>
      <CheckoutLeft
        backgroundColor={$brandSettings?.primaryColor}
        color={$brandSettings?.secondaryColor}
      >
        <Wrapper>
          <SummaryWrapper>
            <Title />
            {!$checkoutProduct?.products?.length && (
              <SubSummaryWrapper>
                <label>Enter Amount</label>
                <QtyNum
                  backgroundColor={$brandSettings?.secondaryColor}
                  color={$brandSettings?.primaryColor}
                  css={`
                    width: 80%;
                    padding: 8px;
                  `}
                  placeholder="100"
                  type={"number"}
                  onKeyUp={(e: any) => updateAdhocProductAmount(e)}
                  onChange={(e: any) => updateAdhocProductAmount(e)}
                  defaultValue={visaState?.productPrice || ""}
                />
              </SubSummaryWrapper>
            )}
            {$checkoutProduct?.products?.map(
              (
                { ProductInstance, id, letCustomerAdjustQuantity }: any,
                index: number
              ) => (
                <ProductInfo key={id}>
                  <ProductImageWrapper>
                    {/* <ProductImage
                    src={productDetails.image}
                    alt={ProductInstance.name}
                  /> */}
                    <NameQty color={$brandSettings?.secondaryColor}>
                      <Name color={$brandSettings?.secondaryColor}>
                        {ProductInstance.name}
                      </Name>
                      {!readOnly && (
                        <Quantity color={$brandSettings?.secondaryColor}>
                          Quantity:
                          <QtyNum
                            backgroundColor={$brandSettings?.secondaryColor}
                            color={$brandSettings?.primaryColor}
                            type={"number"}
                            onKeyUp={(e: any) =>
                              handleProductUpdate(index, e, ProductInstance)
                            }
                            onChange={(e: any) =>
                              handleProductUpdate(index, e, ProductInstance)
                            }
                            max={ProductInstance.quantity}
                            defaultValue={1}
                            disabled={!letCustomerAdjustQuantity}
                          />
                          x {ProductInstance.quantity}
                        </Quantity>
                      )}
                    </NameQty>
                  </ProductImageWrapper>
                  <ProductPrice>
                    {transformPrice(
                      ProductInstance.price *
                        ($selectedProduct?.[index].quantity || 0)
                    )}
                  </ProductPrice>
                </ProductInfo>
              )
            )}
            <SubTax>
              <ProductInfo $noBorder>
                <Label>Sub total</Label>
                <Value>{transformPrice(totalPrice)}</Value>
              </ProductInfo>
              <ProductInfo $noBorder>
                <Label>Tax</Label>
                <Value>{transformPrice(productDetails.tax)}</Value>
              </ProductInfo>
            </SubTax>
            <ProductInfo1>
              <Label>Total</Label>
              <Value1>{transformPrice(totalPrice)}</Value1>
            </ProductInfo1>
          </SummaryWrapper>
        </Wrapper>
      </CheckoutLeft>
      <CheckoutRight></CheckoutRight>
    </CheckoutWrapper>
  );
};

export default CheckoutPageComponent;
